var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.45,97.66a24.67,24.67,0,0,0-10-4.73A21.2,21.2,0,0,1,10.16,72.32V22A21.18,21.18,0,0,1,31.34.82H81.66A21.18,21.18,0,0,1,102.84,22V72.32A21.2,21.2,0,0,1,86.51,92.93a24.67,24.67,0,0,0-10,4.73L60.46,110.77a6.27,6.27,0,0,1-7.92,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.51,10.2H81.66A11.8,11.8,0,0,1,93.46,22V72.32a11.8,11.8,0,0,1-11.8,11.8H31.34a11.8,11.8,0,0,1-11.8-11.8V22.17A12,12,0,0,1,31.51,10.2Z",
    fill: "url(#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88,47.14A31.5,31.5,0,1,1,56.51,15.7,31.52,31.52,0,0,1,88,47.14ZM29.85,47A26.65,26.65,0,1,0,56.67,20.44,26.66,26.66,0,0,0,29.85,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.65,53.71a4.88,4.88,0,0,1-8.93,2.71c-.55-.86-1-1.79-1.45-2.7q-2.88-5.62-5.75-11.27c-.48-1-1-1.91-1.45-2.88a4.89,4.89,0,0,1,8.49-4.83c.51.79.9,1.66,1.33,2.5l4.19,8.22c1,2,2,4,3,6A4.66,4.66,0,0,1,70.65,53.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.91,52.82A5.79,5.79,0,1,1,48.16,47,5.77,5.77,0,0,1,53.91,52.82Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAther);
export default __webpack_public_path__ + "static/media/Ather.fae29707bdf7a85633548fc3facc8f3b.svg";
export { ForwardRef as ReactComponent };